import { AutogenLayoutPayAdjustmentCodeList } from "./autogen/AutogenLayoutPayAdjustmentCodeList";

export class PayAdjustmentCodeList extends AutogenLayoutPayAdjustmentCodeList {
    onLoad(): void | Promise<void> {
    }
}
